var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrike({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67 10.623c.968 0 1.418.174 2.121.88l3.759 3.789c.115.116.138.162.15.22.011.023.011.058.011.081s0 .058-.011.081c-.023.07-.046.116-.15.22L9.99 18.49c-.115.116-.15.14-.219.162a.195.195 0 01-.08.012c-.023 0-.058 0-.081-.012-.07-.023-.115-.046-.22-.162l-7.274-7.333c-.207-.209-.138-.533.22-.533H6.67zM17.265 6c-.968 0-1.418.174-2.121.88l-3.758 3.789c-.116.116-.139.162-.15.22-.012.023-.012.058-.012.081s0 .058.012.081c.023.07.046.116.15.22l2.559 2.584c.115.115.15.139.219.162.023.011.058.011.08.011.024 0 .058 0 .081-.011.07-.023.116-.046.22-.162l7.274-7.334c.208-.208.139-.521-.219-.521h-4.335z",
    fill: "#48B862"
  })));
}

export default SvgWrike;